// ✅ RefinanceForm.jsx — Main Multi-Step Flow Controller
import React, { useState } from "react";
import styles from "./RefinanceForm.module.css";

import ProgressBar from "./ProgressBar";
import ClientTopNav from "./ClientTopNav"; // ✅ in same folder as RefinanceStart etc

// ✅ Steps
import RefinanceStart from "./RefinanceStart";
import RefinanceGoal from "./RefinanceGoal";
import LoanDetails from "./LoanDetails";
import ApplicantDetails from "./ApplicantDetails";
import Income from "./Income";
import Liabilities from "./Liabilities";
import SummarySubmit from "./SummarySubmit";

function RefinanceForm() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({ applicant1: {} });

  const totalSteps = 7;
  const nextStep = () => setStep((prev) => Math.min(totalSteps, prev + 1));
  const prevStep = () => setStep((prev) => Math.max(1, prev - 1));

  const stepLabels = [
    "Mobile Verification",
    "Refinance Goal",
    "Loan Details",
    "Applicant Details",
    "Income",
    "Liabilities",
    "Review & Submit",
  ];

  return (
    <div className={styles.refinanceContainer}>
      {/* ✅ Top nav always visible */}
      <ClientTopNav />

      {/* ✅ Progress directly under top nav */}
      <div className={styles.progressUnderNav}>
        <ProgressBar step={step} totalSteps={totalSteps} stepLabels={stepLabels} />
      </div>

      {/* ✅ Steps */}
      {step === 1 && (
        <RefinanceStart formData={formData} setFormData={setFormData} nextStep={nextStep} />
      )}

      {step === 2 && (
        <RefinanceGoal
          formData={formData}
          setFormData={setFormData}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      )}

      {step === 3 && (
        <LoanDetails
          formData={formData}
          setFormData={setFormData}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      )}

      {step === 4 && (
        <ApplicantDetails
          formData={formData}
          setFormData={setFormData}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      )}

      {step === 5 && (
        <Income
          formData={formData}
          setFormData={setFormData}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      )}

      {step === 6 && (
        <Liabilities
          formData={formData}
          setFormData={setFormData}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      )}

      {step === 7 && (
        <SummarySubmit formData={formData} setFormData={setFormData} prevStep={prevStep} />
      )}
    </div>
  );
}

export default RefinanceForm;